import { Box } from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { preferitiRequestNumberState, preferitiState } from "../atoms/portale";
import { Preferito } from "../models/ServiceDescriptor";
import apiService from "../services/api";
// import logConstants from "../utils/logConstants";
import HomeSegment from "./HomeSegment";
import { PreferredCard } from "./PreferredCard";
import { useUser } from "../atoms";

export const PreferitiSegment = () => {
    const preferiti = useRecoilValue(preferitiState);
    const setPreferitiRequestNumberState = useSetRecoilState(preferitiRequestNumberState)
    const handleOptionsToggle = (elAnchor: HTMLElement) => {
        // console.log(`%chandleOptionsToggle: %o`, logConstants.green12ptBold, elAnchor)
        const ids = preferiti?.map(p => p.id)
        ids && (ids.length > 0) && apiService.savePrefOrder(ids)
    }
    const enableOptions: boolean | undefined = undefined
    const handleMove = (newpref?: Preferito[]) => {
        // console.log(`%cPreferitiSegment:handleMove: %o`, logConstants.blue10ptBold, newpref)
        if (newpref) {
            apiService.savePrefOrder(newpref.map(v => v.id))
                .then(() => setPreferitiRequestNumberState(current => current + 1))
        }
    }
    // console.log({preferiti});
    // console.log({user});
    return (
        <HomeSegment title='Preferiti' nrec={preferiti?.length} onOptionsToggle={enableOptions && handleOptionsToggle}>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                mt: 2,
                px: 0.5,
            }}>
                {preferiti && preferiti.map(p => <PreferredCard key={p.id} item={p} preferiti={preferiti} onMove={handleMove} />)}
            </Box>
        </HomeSegment>
    )
}
export default PreferitiSegment